import { Layout } from "react-grid-layout";
import { IOptionsState } from "../selectableOptions/types";
import { ISelectedItems } from "../selected/types";
import { IError } from "../types/errors";
import { IPage } from "./../pages/types";
import { ActionType } from "./../types/store-types";

import {
    IInputData,
    IStyleLable,
    IStyleInput,
    IStyleInputValue,
    IFieldLabelData,
    IFieldInputData,
    IUrlInputData,
    AlignmentTypes,
    FieldsType,
    WidthMeasurement,
    FieldWidth,
    IFieldInput,
    FieldInputType,
    IFieldType,
    Selected,
    CurrentInputEditing,
    ContentType,
    ISingleLineText,
    IPassword,
    NameInput,
    IName,
    AddressInput,
    IAddress,
    IPhone,
    IUrl,
    INumber,
    NumberContentType,
    IStarRating,
    IBoomformField,
    IEmail,
    IScaleRating,
    ITerms,
    IMap,
    IPrice,
    ITime,
    ICheckbox,
    IRadio,
    ICustomHTML,
    ISignature,
    ITimeZone,
    IDropdown,
    IMapMarker,
    IFileUpload,
    IPaymentPromoCode,
    IPaymentPaymentMethod,
} from "./boomtypes";

export {
    AlignmentTypes,
    FieldsType,
    WidthMeasurement,
    FieldWidth,
    FieldInputType,
    IFieldType,
    Selected,
    ContentType,
    NameInput,
    AddressInput,
    NumberContentType,
};

export type {
    IName,
    IAddress,
    IPhone,
    INumber,
    IUrl,
    IEmail,
    IBoomformField,
    ISingleLineText,
    IUrlInputData,
    IPassword,
    CurrentInputEditing,
    IFieldInput,
    IInputData,
    IStyleLable,
    IStyleInput,
    IStyleInputValue,
    IFieldLabelData,
    IFieldInputData,
    IStarRating,
    IScaleRating,
    ITerms,
    IMap,
    IPrice,
    ITime,
    ICheckbox,
    IRadio,
    ISignature,
    ITimeZone,
    ICustomHTML,
    IDropdown,
    IFileUpload,
    IPaymentPromoCode,
    IPaymentPaymentMethod,
};

export enum FieldGroups {
    NONE,
    INPUT,
    CHOICES,
    DATE_AND_TIME,
    TEXTS,
    ADVANCED,
}

export interface IField {
    _id: string;
    tempId?: string;
    type: FieldTypes;
    name: string;
    group: FieldGroups;
    elements: ISelectedItems[];
    createdAt?: string;
    updatedAt?: string;
    markers?: IMapMarker[];
    options?: IOptionsState[];
}

export interface IFieldResponseData extends IField {
    label: IBoomformField["label"];
}

export enum FieldTypes {
    SINGLE_LINE_TEXT = "INPUT_SINGLE_LINE_TEXT",
    INPUT_MULTI_LINE_TEXT = "INPUT_MULTI_LINE_TEXT",
    NAME = "INPUT_NAME",
    ADDRESS = "INPUT_ADDRESS",
    EMAIL = "INPUT_EMAIL",
    PHONE = "INPUT_PHONE",
    NUMBER = "INPUT_NUMBER",
    URL = "INPUT_URL",
    PASSWORD = "INPUT_PASSWORD",
    PRICE = "INPUT_PRICE",
    CHECKBOX = "SELECT_CHECKBOX",
    RADIO = "SELECT_RADIO",
    DROPDOWN = "SELECT_DROPDOWN",
    STAR_RATING = "SELECT_STAR_RATING",
    SCALE_RATING = "SELECT_SCALE_RATING",
    TERMS = "SELECT_TERM_AND_CONDITION",
    DATE = "DATE",
    TIME = "TIME",
    // DATE_AND_TIME = "DATE_AND_TIME",
    TIMEZONE = "TIME_ZONE",
    HEADEING = "HEADING_TEXT",
    DESCRIPTION = "DESCRIPTION_TEXT",
    MAP = "MAP",
    CUSTOM_HTML = "CUSTOM_HTML",
    FILE_UPLOAD = "FILE",
    SIGNATURE = "SIGNATURE",
    // FILL_IN_THE_BLANK = "FILL_IN_THE_BLANK",
    // MATRIX = "MATRIX",
    PROMOCODE = "INPUT_PROMOCODE",
    PAYMENT_METHOD = "SELECT_PAYMENT_METHOD",
}

/* Field Editable Object Types */

// Commmon types
// Fields types
export const payableFields = [
    FieldTypes.NUMBER,
    FieldTypes.CHECKBOX,
    FieldTypes.DROPDOWN,
    FieldTypes.RADIO,
    FieldTypes.PRICE,
    FieldTypes.PROMOCODE,
    FieldTypes.PAYMENT_METHOD,
];

export const fieldsCanSubscribtion = [FieldTypes.CHECKBOX, FieldTypes.DROPDOWN, FieldTypes.RADIO , FieldTypes.PAYMENT_METHOD];

export type CurrentField = null | IField["_id"];

/* - Actions Data Types - */

export interface IInitFieldsData {
    list: IFieldResponseData[];
}

export interface IAddFieldSuccessData {
    fieldId: IField["_id"];
    tempId: IField["_id"];
}
/* -- Add Field Data Types --  */

export interface IAddFieldWithTempIdData {
    id: IField["_id"];
    type: FieldTypes;
    data?:Partial<IBoomformField & IField>

}

export interface IAddFieldRequestData {
    type: FieldTypes;
    pageId: IPage["_id"];
    layout: Layout | null;
    data?:Partial<IBoomformField & IField>
}

export interface IAddFieldFailureData extends IError {}

/* -- Update Field Data Types --  */

export interface IUpdateFieldRequestData {
    _id: IField["_id"];
    data: any;
    type: IField["type"];
}

export interface IUpdateFieldSuccessData {}

export interface IUpdateFieldFailureData extends IError {}

/* -- Delete Field Data Types --  */

export interface IDeleteFieldRequestData {
    fieldId: IField["_id"];
    pageId: IPage["_id"];
}

export interface IDeleteFieldSuccessData {}

export interface IDeleteFieldFailureData extends IError {}

/* -- Duplicate Field Data Types --  */

export interface IDuplicateFieldWithTempIdData {
    fieldId: IField["_id"];
    tempId: IField["_id"];
    index: number;
}

export interface IDuplicateFieldRequestData {
    pageId: IPage["_id"];
    fieldId: IField["_id"];
    pageFieldsIds: IField["_id"][];
    fieldType: FieldTypes;
    index: number;
    options?: IOptionsState;
}

export interface IDuplicateFieldSuccessData {
    fieldId: IField["_id"];
    tempId: IField["_id"];
}

export interface IDuplicateFieldFailureData extends IError {}

interface IChangeIsFormHavePromoCodeField {
    value: boolean;
}
interface IChangeIsFormHavePaymentTypeField {
    value: boolean;
}

/* - State - */

export interface IFieldsState {
    list: IField[];
    isLoading: boolean;
    isHavePromoCodeField: boolean;
    isHavePaymentTypeField: boolean;
}

/* - Action Types - */

export enum FieldsActionTypes {
    INIT_FIELDS = "FIELDS.INIT_FIELDS",
    ADD_FIELD = "FIELDS.ADD_FIELD",
    ADD_WITH_TEMP_ID = "FIELDS.ADD_WITH_TEMPORARY_ID",
    ADD_FIELD_REQUEST = "FIELDS.ADD_FIELD_REQUEST",
    ADD_FIELD_SUCCESS = "FIELDS.ADD_FIELD_SUCCESS",
    ADD_FIELD_FAILURE = "FIELDS.ADD_FIELD_FAILURE",

    UPDATE_FIELD_REQUEST = "FIELDS.UPDATE_FIELD_REQUEST",
    UPDATE_FIELD_SUCCESS = "FIELDS.UPDATE_FIELD_SUCCESS",
    UPDATE_FIELD_FAILURE = "FIELDS.UPDATE_FIELD_FAILURE",

    DELETE_FIELD_REQUEST = "FIELDS.DELETE_FIELD_REQUEST",
    DELETE_FIELD_SUCCESS = "FIELDS.DELETE_FIELD_SUCCESS",
    DELETE_FIELD_FAILURE = "FIELDS.DELETE_FIELD_FAILURE",

    DUPLICATE_FIELD_REQUEST = "FIELDS.DUPLICATE_FIELD_REQUEST",
    DUPLICATE_FIELD_WITH_TEMP_ID = "FIELDS.DUPLICATE_FIELD_TEMP_WITH_ID",
    DUPLICATE_FIELD_SUCCESS = "FIELDS.DUPLICATE_FIELD_SUCCESS",
    DUPLICATE_FIELD_FAILURE = "FIELDS.DUPLICATE_FIELD_FAILURE",
    CHANGE_IS_FORM_HAVE_PROMOCODE_FIELD = "PAYMENT.CHANGE_IS_FORM_HAVE_PROMOCODE_FIELD",
    CHANGE_IS_FORM_HAVE_PAYMENT_TYPE_FIELD = "PAYMENT.CHANGE_IS_FORM_HAVE_PAYMENT_TYPE_FIELD",
}

/* - Action Interfaces  - */

export type InitFieldsActionType = ActionType<FieldsActionTypes.INIT_FIELDS, IInitFieldsData>;

/* -- Add Field Action Types -- */
export type AddFieldWithTempIdActionType = ActionType<FieldsActionTypes.ADD_WITH_TEMP_ID, IAddFieldWithTempIdData>;
export type AddFieldRequestActionType = ActionType<FieldsActionTypes.ADD_FIELD_REQUEST, IAddFieldRequestData>;
export type AddFieldSuccessActionType = ActionType<FieldsActionTypes.ADD_FIELD_SUCCESS, IAddFieldSuccessData>;
export type AddFieldFailureActionType = ActionType<FieldsActionTypes.ADD_FIELD_FAILURE, IAddFieldFailureData>;

/* -- Update Field Action Types -- */
export type UpdateFieldRequestActionType = ActionType<FieldsActionTypes.UPDATE_FIELD_REQUEST, IUpdateFieldRequestData>;
export type UpdateFieldSuccessActionType = ActionType<FieldsActionTypes.UPDATE_FIELD_SUCCESS, IUpdateFieldSuccessData>;
export type UpdateFieldFailureActionType = ActionType<FieldsActionTypes.UPDATE_FIELD_FAILURE, IUpdateFieldFailureData>;

/* -- Delete Field Action Types -- */
export type DeleteFieldRequestActionType = ActionType<FieldsActionTypes.DELETE_FIELD_REQUEST, IDeleteFieldRequestData>;
export type DeleteFieldSuccessActionType = ActionType<FieldsActionTypes.DELETE_FIELD_SUCCESS, IDeleteFieldSuccessData>;
export type DeleteFieldFailureActionType = ActionType<FieldsActionTypes.DELETE_FIELD_FAILURE, IDeleteFieldFailureData>;

/* -- Duplicate Field Action Types -- */
export type DuplicateFieldWithTempIdActionType = ActionType<
    FieldsActionTypes.DUPLICATE_FIELD_WITH_TEMP_ID,
    IDuplicateFieldWithTempIdData
>;
export type DuplicateFieldRequestActionType = ActionType<
    FieldsActionTypes.DUPLICATE_FIELD_REQUEST,
    IDuplicateFieldRequestData
>;
export type DuplicateFieldSuccessActionType = ActionType<
    FieldsActionTypes.DUPLICATE_FIELD_SUCCESS,
    IDuplicateFieldSuccessData
>;
export type DuplicateFieldFailureActionType = ActionType<
    FieldsActionTypes.DUPLICATE_FIELD_FAILURE,
    IDuplicateFieldFailureData
>;
export type ChangeIsFomHavePromoCodeFieldActionType = ActionType<
    FieldsActionTypes.CHANGE_IS_FORM_HAVE_PROMOCODE_FIELD,
    IChangeIsFormHavePromoCodeField
>;
export type ChangeIsFomHavePaymentTypeFieldActionType = ActionType<
    FieldsActionTypes.CHANGE_IS_FORM_HAVE_PAYMENT_TYPE_FIELD,
    IChangeIsFormHavePaymentTypeField
>;
